<template>
    <form>
        <div class="alert alert-danger" v-if="error">{{ error }}</div>
        <div class="form-row">
            <div class="col">
                <v-input
                    :disabled="saving"
                    label="First Name"
                    v-model="firstName"
                    required
                />
            </div>
            <div class="col">
                <v-input
                    :disabled="saving"
                    required
                    label="Last Name"
                    v-model="lastName"
                />
            </div>
        </div>
        <div class="mt-3 form-row">
            <div class="col">
                <v-input
                    required
                    :disabled="saving"
                    label="Email"
                    type="email"
                    v-model="email"
                />
            </div>
            <div class="col">
                <v-input
                    required
                    :disabled="saving"
                    label="Phone"
                    type="phone"
                    v-model="phone"
                />
            </div>
        </div>
        <div class="mt-3 form-row">
                        <div class="col">
                <v-input
                    required
                    :disabled="saving"
                    label="Password"
                    type="password"
                    v-model="password"
                />
            </div>
        </div>
        <div class="mt-3 form-row">
            <div class="col-6">
                <v-select
                    required
                    :disabled="saving"
                    :options="months"
                    label="Birthday Month"
                    name="birth_month"
                    v-model="birthmonth"
                />
            </div>
            <div class="col-3">
                <v-input
                    required
                    :disabled="saving"
                    label="Day"
                    name="birth_day"
                    type="number"
                    v-model="birthday"
                />
            </div>
            <div class="col-3">
                <v-input
                    required
                    :disabled="saving"
                    label="Year"
                    name="birth_year"
                    type="number"
                    v-model="birthyear"
                />
            </div>
        </div>

        <template v-if="!noFooter">
            <v-flex align="center" class="mt-3" justify="end">
                <v-button
                    :disabled="saving"
                    @click.prevent="save"
                    block
                    variant="primary"
                    >Sign up</v-button
                >
            </v-flex>
            <div class="mt-3 small text-right text-muted ml-auto">
                By signing up for Ladder, you agree to the Ladder
                <a href="/terms" target="_blank">Terms of Service</a> and have
                read the Ladder
                <a href="/privacy" target="_blank">Privacy Policy</a>
            </div>
        </template>
    </form>
</template>

<script>
import VInput from "@@/components/VInput";
import VSelect from "@@/components/VSelect";
import store from "@/store.js";

export default {
    name: "VFormSignUp",
    components: { VInput, VSelect },
    props: {
        noFooter: {
            type: Boolean
        }
    },
    data() {
        return {
            shared: store.state,
            saving: false,
            error: null,
            firstName: "",
            lastName: "",
            email: "",
            phone:"",
            birthmonth: "",
            birthday: "",
            birthyear: "",
            password: "",
            months: {
                January: "01",
                February: "02",
                March: "03",
                April: "04",
                May: "05",
                June: "06",
                July: "07",
                August: "08",
                September: "09",
                October: "10",
                November: "11",
                December: "12"
            }
        };
    },
    computed: {
        account() {
            return {
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
                phone: this.phone,
                password: this.password,
                birthdate: `${this.birthyear}-${this.birthmonth}-${this.day}`
            };
        },
        day() {
            return this.birthday < 10 ? `0${this.birthday}` : this.birthday;
        }
    },
    methods: {
        // Save the user or return the existing logged in user
        async save() {

            // Ensure the form is valid.
            if (!this.$el.reportValidity())
                return Promise.reject();

            this.$el.classList.add("was-validated");
            // Clear the form display state
            this.error = null;
            this.saving = true;

            // If there is a user already logged in, return that user
            if (this.shared.user) {
                return Promise.resolve(this.shared.user);
            }

            try {
                let user = await this.$ladder.signUp(this.account);
                // Save the auth token
                this.$ladder.setAuthToken(user.auth_token);
                // Store the user in the shared store
                store.setUser(user);
                // Emit a success event
                this.$emit("success", user);
                // Return a promise for chaining of sign up flows
                return Promise.resolve(user);
            } catch (e) {
                // Show the error message
                this.error = e.message;
                // Emit an error event for parent components
                this.$emit("error", e);
                // Return a promise rejection for chaining flows
                return Promise.reject(e);
            } finally {
                this.saving = false;
            }
        }
    }
};
</script>
